import { BaseMenuHelpPanel } from "./BaseMenuHelpPanel";
import { text } from "../../TextResources";
import { Env } from "../../settings/Env";
import { Image3D } from "@dreamcam/babylon-tools";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
export class BroadcastMenuHelpPanel extends BaseMenuHelpPanel {
    _getControlNamePrefix() {
        return "broadcastMenuHelpPanel";
    }
    _createContent() {
        this._root.addControl(this._createControllerImage());
        this._addLabels();
        this._root.addControl(this._createDragImage());
        this._root.addControl(this._createCloseImage());
        const hp = Env.broadcast.menu.helpPanel;
        const dragSection = this._addDragSection();
        dragSection.leftInPixels = this._mesh2d.m2px(hp.infographics.dragSection.left);
        dragSection.topInPixels = this._mesh2d.m2px(hp.infographics.dragSection.top);
        const closeSection = this._addCloseSection();
        closeSection.leftInPixels = this._mesh2d.m2px(hp.infographics.closeSection.left);
        closeSection.topInPixels = this._mesh2d.m2px(hp.infographics.closeSection.top);
    }
    _createControllerImage() {
        const im = Env.broadcast.menu.helpPanel.controllerImage;
        const result = new Image3D(`${this._getControlNamePrefix()}InfographicsController`, im.img);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.leftInPixels = this._mesh2d.m2px(im.left);
        result.topInPixels = this._mesh2d.m2px(im.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _createDragImage() {
        const im = Env.broadcast.menu.helpPanel.infographics;
        const result = new Image3D(`${this._getControlNamePrefix()}InfographicsDrag`, im.dragImg);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.leftInPixels = this._mesh2d.m2px(im.dragSection.image.left);
        result.topInPixels = this._mesh2d.m2px(im.dragSection.image.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _createCloseImage() {
        const im = Env.broadcast.menu.helpPanel.infographics;
        const result = new Image3D(`${this._getControlNamePrefix()}InfographicsClose`, im.closeImg);
        result.heightInPixels = this._mesh2d.m2px(im.height);
        result.widthInPixels = this._mesh2d.m2px(im.width);
        result.leftInPixels = this._mesh2d.m2px(im.closeSection.image.left);
        result.topInPixels = this._mesh2d.m2px(im.closeSection.image.top);
        result.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        return result;
    }
    _addLabels() {
        const hp = Env.broadcast.menu.helpPanel;
        this._addLabel("Select", text.broadcast_menu_helpPanel_controller_select, hp.controller.text.positions.select);
        this._addLabel("Lobby", text.broadcast_menu_helpPanel_controller_lobby, hp.controller.text.positions.lobby);
        this._addLabel("Tip", text.broadcast_menu_helpPanel_controller_tip, hp.controller.text.positions.tip);
        this._addLabel("Drag", text.broadcast_menu_helpPanel_controller_drag, hp.controller.text.positions.drag);
        this._addLabel("PrevNext", text.broadcast_menu_helpPanel_controller_prev_next, hp.controller.text.positions.prevNext);
        this._addLabel("Zoom", text.broadcast_menu_helpPanel_controller_zoom, hp.controller.text.positions.zoom);
        this._addLabel("Reset", text.broadcast_menu_helpPanel_controller_reset, hp.controller.text.positions.reset);
        this._addLabel("Recenter", text.broadcast_menu_helpPanel_controller_recenter, hp.controller.text.positions.recenter);
        this._addIcon("PrevNext", hp.controller.icons.leftRight, hp.controller.icons.positions.prevNext);
        this._addIcon("Zoom", hp.controller.icons.upDown, hp.controller.icons.positions.zoom);
        this._addIcon("Reset", hp.controller.icons.press, hp.controller.icons.positions.reset);
        this._addIcon("Recenter", hp.controller.icons.longPress, hp.controller.icons.positions.recenter);
        this._addSubLabel("Lobby", hp.controller.longPressText.positions.lobby);
        this._addSubLabel("Tip", hp.controller.longPressText.positions.tip);
        this._addSubLabel("PrevNext", hp.controller.longPressText.positions.prevNext);
        this._addSubLabel("Recenter", hp.controller.longPressText.positions.recenter);
    }
}
